import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { EventMap, MapPin } from '../schema';
import { db } from '../instant';
import { deleteCachedImage } from '../upload';

interface Props {
    eventName: string;
    map?: EventMap;
    open: boolean;
    onClose: () => void;
}

export default function DeleteMapDialog(props: Props) {
    const { user } = db.useAuth();

    if (props.map === null) {
        return <></>;
    }

    const deleteAndClose = async () => {
        if (props.map) {
            const pins = props.map.pins || [];

            // Delete cached image to free up cache space and prevent stale content
            if (props.map.bgImageUrl) {
                try {
                    await deleteCachedImage(props.map.bgImageUrl);
                } catch (error) {
                    console.warn('Failed to delete cached image:', error);
                    // Continue with deletion even if cache cleanup fails
                }
            }

            // NOTE: not deleting images from R2 for ease of backup restoration

            // Delete map pins for this event
            const deletePins = pins.map((pin: MapPin) => db.tx.mapPins[pin.id].delete());

            await db.transact([db.tx.maps[props.map.id].delete(), ...deletePins]);

            props.onClose();
        }
    };

    const eventName = props.eventName || '<UNDEFINED>';
    const mapName = props.map?.name || '<UNDEFINED>';

    return (
        <Dialog open={props.open} onClose={props.onClose}>
            <DialogTitle>Really delete this map?</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    The map &quot;{mapName}&quot; of event &quot;{eventName}&quot; will be deleted. This action cannot be undone.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose} autoFocus>
                    Cancel
                </Button>
                <Button disabled={!user} onClick={deleteAndClose} color="error">
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );
}
